import * as yup from "yup";
import type { Asserts } from "yup";

// Response from /user/invoice-addresses validation

const privateAddressSchema = yup.object({
  type: yup
    .string()
    .matches(/private/)
    .required(),
  contactName: yup.string().nullable().optional(),
  contactEmail: yup.string().nullable().optional(),
  contactPhone: yup.string().nullable().optional(),
  isDefault: yup.bool().nullable().optional(),
});

const companyAddressSchema = yup.object({
  type: yup
    .string()
    .matches(/company/)
    .required(),
  companyName: yup.string().nullable().optional(),
  email: yup.string().nullable().optional(),
  companyCode: yup.string().nullable().optional(),
  companyVat: yup.string().nullable().optional(),
  country: yup.string().nullable().optional(),
  countryCode: yup.string().nullable().optional(),
  city: yup.string().nullable().optional(),
  street: yup.string().nullable().optional(),
  streetNumber: yup.string().nullable().optional(),
  flatNo: yup.string().nullable().optional(),
  zip: yup.string().nullable().optional(),
  isDefault: yup.bool().nullable().optional(),
});

const invoiceAddressesSchema = yup.object({
  private: privateAddressSchema.required(),
  company: companyAddressSchema.required(),
});

export type TInvoiceAddressesResponse = Asserts<typeof invoiceAddressesSchema>;

const validateInvoiceAddressesResponse = (response: any): TInvoiceAddressesResponse =>
  invoiceAddressesSchema.validateSync(response);

export default validateInvoiceAddressesResponse;
